import React from 'react'
import IndividualNote from './IndividualNote';
import Main from './Main';

function Home() {
    return (

        <div className="container">
            <Main />

            <div className="box notes-box">
                <IndividualNote />
            </div>

        </div>

    )
}

export default Home
